import React, { useEffect, useState } from "react";
import "./ProfileComponent.css";
import Circularprogressbar from "../Circularprogressbar";
import profile from "../../assets/images/prf.png";
import user from "../../assets/users.jpeg";
import edits from "../../assets/images/edit.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  Profile_Image,
  UserDetails,
  addProfileImage,
  login,
  userlogout,
} from "../../redux/userSlice";
import { darkTheme, lightTheme, themeMode } from "../../redux/themeSlice";
import { MdEdit } from "react-icons/md";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";


const ProfileComponent = () => {
  const userDetails = useSelector(UserDetails);
  const thememode = useSelector(themeMode);
  const [changePasswordStatus, setChangePasswordStatus] = useState(false);
  const [editProfileStatus, setEditProfileStatus] = useState(false);

  const dispatch = useDispatch();
  const [themeStatus, setThemeStatus] = useState(thememode);
  const APi_Url = process.env.REACT_APP_ENIGMA_API;

  const firstName = userDetails?.firstName;
  const lastName = userDetails?.lastName;
  const ShortName = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();



  const User_Name = userDetails?.firstName + " " + userDetails?.lastName;

 
  const [PhoneNumber, setPhoneNumber] = useState('');


useEffect(()=>{
  fetchUserDetails();
},[]);

  const fetchUserDetails=async()=>{
    try {
      const response = await axios.get(
        `${APi_Url}api/Profile/Get_Profile/${userDetails.id}`,
        
        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.status===200){
      console.log("resposne profile photo", response?.data?.response?.phoneNumber);
      setPhoneNumber(response?.data?.response?.phoneNumber);
    }
     
    } catch (error) {
      console.error("Error uploading image:", error);
    }

  };



  useEffect(() => {
    if (themeStatus) {
      dispatch(lightTheme());
    } else {
      dispatch(darkTheme());
    }
  }, [themeStatus, dispatch]);

  useEffect(() => {
    setThemeStatus(thememode);
  }, [thememode]);

  const { userEmail } = userDetails;

  const token = userDetails?.token;
  const Profile_Image_Url = useSelector(Profile_Image);



  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append("Image", file);
    formData.append("UserId", userDetails.id);

    // console.log('formData', formData);

    try {
      const response = await axios.post(
        `${APi_Url}api/Profile/update-profile`,
        formData,
        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
     
      if (response.status === 200) {
        // console.log('Image uploaded successfully:', response.data.response.profileImageUrl);
        // dispatch(addProfileImage(response.data.response.profileImageUrl));
        
        const profileImageUrl = `${response.data.response.profileImageUrl}?${new Date().getTime()}`;
      dispatch(addProfileImage(profileImageUrl));
      toast.success("Your profile photo successfully updated");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  const initialValues = {
    old_Password: "",
    new_Password: "",
    confirm_Password: "",
  };

  const validationSchema = Yup.object({
    old_Password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is Required"),

    new_Password: Yup.string()
      .min(6, "New password must be at least 6 characters")
      .required("Newpassword is Required"),
    confirm_Password: Yup.string()
      .oneOf([Yup.ref("new_Password"), null], "Passwords must match")
      .required("Confirm Password is Required"),
  });

  // changePassword onsubmit function
  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    const data = {
      userId: userDetails.id,
      ...values,
    };

    //  "#accountModal".modal("hide");
    // isDeleted: true,

    try {
      const response = await axios.post(
        `${APi_Url}api/Profile/Change_Password`,
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // toast.success("Successfully add account");
      if (response.status === 200) {
        if (response.data.statusCode === 400) {
          toast.error(response.data.response);
        }
        if (response.data.statusCode === 200) {
          toast.success(response.data.response);
          dispatch(userlogout());
          sessionStorage.removeItem("token");
        }
      }
      console.log("change password response", response);
      setChangePasswordStatus(false);
      resetForm();
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const profileuploadinitialValues = {
    FirstName: userDetails?.firstName || "",
    LastName: userDetails?.lastName || "",
    PhoneNumber: PhoneNumber || "",
  };

  const profileuploadvalidationSchema = Yup.object({
    FirstName: Yup.string()
      .min(1, "First Name must be at least 1 characters")
      .test(
        "no-spaces",
        "First Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("First Name is Required"),
    LastName: Yup.string()
      .min(1, "Last Name must be at least 1 characters")
      .test(
        "no-spaces",
        "Last Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("Last Name is Required"),
    PhoneNumber: Yup.string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone number is Required")
      .min(10, "Phone number too short")
      .max(10, "Phone number too long"),
  });

  const handelProfileUpload = async (values, { setSubmitting, resetForm }) => {
    const data = {
      userId: userDetails.id,
      ...values,
    };
    try {
      const response = await axios.post(
        `${APi_Url}api/Profile/update-profile`,
        data,
        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("profile update successfully:", response.data.response);

      
      // firstName: userDetails.getusers[0].firstName,
      // lastName: userDetails.getusers[0].lastName,
      // token:response.data.response.token,
      // phonenumber:userDetails.phoneNumber
      toast.success("Your profile update successfully");

      dispatch(
        login({
          user: {
            id: response.data.response.userId,
            role: userDetails.role,
            userEmail: userDetails.userEmail,
            firstName: response.data.response.firstName,
            lastName: response.data.response.lastName,
            token: userDetails.token,
          
          },
        })
      );
      fetchUserDetails();
      setEditProfileStatus(false);
    } catch (error) {
      console.error("Error uploading image:", error);
      setEditProfileStatus(false);
    }
  };

  return (
    <>
      <section className="dashbordsect">
        <div className="hadformsect">
          <h2>My profile</h2>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="boxflexlist">
              <div className="whitbox widthfull pd25">
                <div className="profilbox">
                  <div className="prof_imgbox">
                    {Profile_Image_Url.split("?")[0]!='null' ? (
                      <img src={APi_Url + Profile_Image_Url} alt="profile" />
                    ) :userDetails?.firstName==""?<img src={user} style={{borderRadius:100}}alt="user"/>:ShortName}

                    {/* <h5>pk</h5> */}
                    {/* <span className="edit_profile_img">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                      ></input>
                      <MdEdit />
                    </span> */}
                  </div>
                  <div className="profcont">
                    <h3>{User_Name}</h3>
                    {/* <button type="button" className="prfeditbtn">Edit profile</button> */}
                  </div>
                </div>
                <div className="borderbox">
                  <div className="prfheading">
                    <h3>Personal info</h3>
                    <button
                      type="button"
                      className="prfeditbtn"
                      onClick={() => {
                        setEditProfileStatus(true);
                      }}
                    >
                      <img src={edits} alt="edit-icon" />
                      Edit
                    </button>
                  </div>
                  <ul className="personal_info_list">
                    <li>
                      <h4>Email</h4>
                      <h5>{userEmail}</h5>
                    </li>
                    <li>
                      <h4>Phone</h4>
                      <h5>
                        {PhoneNumber
                          ? PhoneNumber
                          : "--"}
                      </h5>
                    </li>
                  </ul>
                </div>
                <div className="borderbox">
                  <div className="prfheading">
                    <h3>Default settings</h3>
                  </div>
                  <div className="swichboxstyl">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        checked={!themeStatus}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={() => setThemeStatus(!themeStatus)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        Dark Mode
                      </label>
                    </div>
                  </div>
                </div>
                <div className="borderbox">
                  <div className="prfheading">
                    <h3>Password</h3>
                  </div>
                  <ul className="password_info">
                    <li>
                      <button
                        type="button"
                        className="prfeditbtn"
                        onClick={() => setChangePasswordStatus(true)}
                      >
                        Change Password
                      </button>
                    </li>
                    {/* <li>
                      <h5>XXXXXXXX</h5>
                    </li> */}
                    {/* <li>
                      <h4>2FA</h4>
                    </li>
                    <li>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4 text-center">
            <div className="whitbox pd25">
              <div className="complete_profile">
                <h3>Complete your profile</h3>
              </div>
              <div className="progressbox">
                <Circularprogressbar />
              </div>
              <ul className="cm_profilelist">
                <li>Set up account</li>
                <li>Upload your photo</li>
                <li>Status</li>
                <li className="unchexk">Account</li>
               
                <li className="unchexk">Others</li>
              </ul>
            </div>
          </div> */}
        </div>
      </section>

      {/* modal for change password start */}
      <div
        className={`modal fade inputmodal ${
          changePasswordStatus ? "show" : ""
        }`}
        aria-hidden="true"
        style={{ display: changePasswordStatus ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1>Change Password</h1>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ resetForm }) => (
                  <Form className="row needs-validation">
                    <div className="col-md-12">
                      {/* old password */}
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          Old password
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="password"
                            id="old_Password"
                            name="old_Password"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="old_Password"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>
                      {/* new password */}
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          New password
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="password"
                            id="new_Password"
                            name="new_Password"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="new_Password"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>

                      {/* confirm password */}
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          Confirm password
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="password"
                            id="confirm_Password"
                            name="confirm_Password"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="confirm_Password"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <button className="btn kevlar_btn" type="submit">
                        Submit
                      </button>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn kevlar_btn"
                        type="button"
                        onClick={() => {
                          setChangePasswordStatus(false);
                          resetForm();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {/* modal for change password end */}

      {/* Modal for edit profile start */}
      <div
        className={`modal fade inputmodal ${editProfileStatus ? "show" : ""}`}
        aria-hidden="true"
        style={{ display: editProfileStatus ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1>Edit Profile</h1>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={profileuploadinitialValues}
                validationSchema={profileuploadvalidationSchema}
                onSubmit={handelProfileUpload}
                enableReinitialize
              >
                {({ resetForm }) => (
                  <Form className="row needs-validation">
                    <div className="col-md-12">
                      {/* old password */}
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          First Name
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="text"
                            id="FirstName"
                            name="FirstName"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="FirstName"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>
                      {/* new password */}
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          Last Name
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="text"
                            id="LastName"
                            name="LastName"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="LastName"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>

                      {/* confirm password */}
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          Phone Number
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="number"
                            id="PhoneNumber"
                            name="PhoneNumber"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="PhoneNumber"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <button className="btn kevlar_btn" type="submit">
                        Submit
                      </button>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn kevlar_btn"
                        type="button"
                        onClick={() => {
                          setEditProfileStatus(false);
                          resetForm();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileComponent;
